module.exports = __webpack_public_path__ + "static/media/wordpress-ai-es.f28dd049.png";